// Where the running timer sits in the shell (PRD 64 §4).
//
// A THIN GATE, and it is the whole job of this file. The shell renders for
// everybody — a personal user, a business owner, a firm member — and the timer
// belongs to none of them but the last. It also renders ABOVE the firm
// screens, so it cannot read anything a firm route owns and has to ask for
// itself.
//
// It asks nothing at all until it knows the person is in a practice with the
// workflow on, so a personal user never makes a firm-scoped call.

import React, { useEffect, useState } from 'react';
import { useBelongsToFirm, usePracticeWorkflow } from '../../hooks/useFirmMembership';
import { firmService } from '../../services/firmService';
import { RunningTimerBar } from './RunningTimerBar';

export const FirmTimerSlot: React.FC = () => {
  const inFirm = useBelongsToFirm();
  const workflow = usePracticeWorkflow();
  const [firmId, setFirmId] = useState<string | null>(null);

  useEffect(() => {
    if (!inFirm || !workflow) return;
    let cancelled = false;
    firmService
      .listFirms()
      .then(list => {
        if (!cancelled) setFirmId(list[0]?.id ?? null);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [inFirm, workflow]);

  if (!inFirm || !workflow || !firmId) return null;

  return <RunningTimerBar firmId={firmId} />;
};

export default FirmTimerSlot;
